import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  ten: {//object, optional // Tên Quốc tịch
    vi: null, //string, optional // Tên tiếng Việt
    en: null, //string, optional // Tên tiếng Anh
  }

};

// validation form
model.validForm = {

  ten: {//object, optional // Tên Quốc tịch
    vi: [ValidService.required], //string, optional // Tên tiếng Việt
    en: [ValidService.required], //string, optional // Tên tiếng Anh
  }
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
};

// validation các form khác
model.validFormOther = {
};

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100, 500],
  allowPaging: false,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "",
  defaultSort: ["ten", "ascending"],
  filters: "",
  recordSelected: [],
  dataSearch: {
    value: {
      "ten.vi": "",
      "ten.en": ""
    },
    valid: {
      "ten.vi": [],
      "ten.en": []
    },
    operator: {
      "ten.vi": ":regex_i:", //:regex:, $vn_text=Viêt nam
      "ten.en": ":regex_i:"
    }
  }
};

export default model;